import { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Steps from './components/Steps';
//import Project from './components/Project';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Mundo from  './components/Mundo';
import Portafolio from './components/Portafolio';
import Herramientas from './components/Herramientas';

function Inicio() {

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target); // Solo se anima una vez
        }
      });
    });

    const elements = document.querySelectorAll('.animate-on-scroll');
    elements.forEach(el => observer.observe(el));
  }, []);

  return (
    <div>
      <Header />
      <Hero />
      <About />
      <Services />
      <Portafolio />
      {/* Sección de Pasos para agendar reunión */}
      <Steps />
      <Herramientas />

       {/* <Project />*/}
      <Contact />
      <Mundo />
      <Footer />

      {/* Botón flotante WhatsApp */}
      <a 
        href="https://wa.me/5217717008001" 
        className="floating-button whatsapp-float" 
        target="_blank" 
        rel="noopener noreferrer"
      >
        <i className="bi bi-whatsapp text-white" style={{ fontSize: '28px' }}></i>
      </a>

      {/* Botón flotante Facebook */}
      <a 
        href="https://www.facebook.com/people/CodeNest-Dev-Desarrollo-Web-y-Movil/100091882179962/" 
        className="floating-button facebook-float" 
        target="_blank" 
        rel="noopener noreferrer"
      >
        <img src="/img/Facebook.png" alt="Facebook" />
      </a>
    </div>
  );
}

export default Inicio;
